import '../styles/BreakScreen.css';

const BREAK_TEXT = 'This Session is on a Break...';

export default function BreakScreen({ topOffset = 0 }) {
  const displayText = BREAK_TEXT;
  return (
    <div className='break_screen_overlay' style={{ top: topOffset }}>
      <div className='break_screen_content'>
        <div className='break_screen_text' aria-label={BREAK_TEXT}>
          {displayText.split('').map((char, i) => (
            <span
              key={`letter-${i}`}
              className='break_screen_letter'
              style={{ animationDelay: `${(i * 0.07) % 1.8}s` }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
